// extracted by mini-css-extract-plugin
export var dropdown = "cart-dropdown-module--dropdown--zEhJM";
export var emptyCartInfo = "cart-dropdown-module--empty-cart-info--XrWjO";
export var link = "cart-dropdown-module--link--W9KtK";
export var loader = "cart-dropdown-module--loader--C+YPD";
export var moreItems = "cart-dropdown-module--more-items--yoGlf";
export var moreItemsText = "cart-dropdown-module--more-items-text--Q7h+t";
export var separator = "cart-dropdown-module--separator--8G485";
export var title = "cart-dropdown-module--title--Ax5xF";